import { Component, Input, ViewEncapsulation } from '@angular/core';
import { IProductTypeOverview } from '@cakeiteasy/web-utils';
import { CakeBuilderLink } from '../cake-builder-link';

@Component({
  standalone: false,
  selector: 'no-image-cake-item',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './no-image-cake-item.component.html',
  styleUrls: ['./no-image-cake-item.component.scss']
})
export class NoImageCakeItemComponent extends CakeBuilderLink {
  @Input() cake: IProductTypeOverview;
  @Input() currency: string;
  @Input() pieces: boolean;
  @Input() isPriceVisible: boolean;
}
